export const rotate = (id) => {
    var el = document.getElementById(id);
    if(el.style.transform == 'rotate(0deg)') {
        el.style.transform = 'rotate(180deg)'
    } else {
        el.style.transform = 'rotate(0deg)'
    }
}